export default __webpack_public_path__ + "static/media/getbanner.cf92ced1a360c3eb939420e1c31a94b1.svg";